export const API_CONTACT_US_ROUTE = '/api/contact-us';
export const API_QUOTE_ROUTE = '/api/quote';
export const API_CAREER_ROUTE = '/api/career';

export type TApiPaths = typeof API_CONTACT_US_ROUTE | typeof API_QUOTE_ROUTE | typeof API_CAREER_ROUTE;
